import CalenderComponent from './CalenderComponent';

export default CalenderComponent;
